import { render, staticRenderFns } from "./Group_chat.vue?vue&type=template&id=4673ff11&scoped=true"
import script from "./Group_chat.vue?vue&type=script&lang=js"
export * from "./Group_chat.vue?vue&type=script&lang=js"
import style0 from "./Group_chat.vue?vue&type=style&index=0&id=4673ff11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4673ff11",
  null
  
)

export default component.exports